import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: 'Решение', href: '#solution' },
    { label: 'Услуги', href: '#services' },
    { label: 'Результаты', href: '#results' },
    { label: 'Кейсы', href: '#cases' },
    { label: 'Калькулятор', href: '#pricing' },
    { label: 'Партнёрам', href: '#referral' },
    { label: 'Блог', href: '/blog' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Контакты', href: '#contact' },
  ];

  return (
    <header className="site-header" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 50,
      background: 'rgba(255, 255, 255, 0.8)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(229, 229, 229, 1)',
    }}>
      <style>{`
        .header-nav { display: none; }
        .header-cta { display: none; }
        .header-phone { display: none; }
        .header-burger { display: block; }

        @media (min-width: 640px) {
          .header-cta { display: inline-flex; }
        }

        @media (min-width: 1024px) {
          .header-nav { display: flex; }
          .header-phone { display: inline-flex; }
          .header-burger { display: none; }
        }
      `}</style>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <a
              href="/"
              style={{ display: 'flex', alignItems: 'center', transition: 'opacity 0.2s', cursor: 'pointer' }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              <img
                src="/images/logo_main_black.webp"
                alt="1Seller"
                className="header-logo"
                style={{ height: '14px', width: 'auto' }}
              />
            </a>
          </div>

          <nav className="header-nav" style={{ alignItems: 'center', gap: '24px', fontSize: '14px' }}>
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                style={{ color: '#525252', textDecoration: 'none', transition: 'color 0.2s', cursor: 'pointer' }}
                onMouseEnter={(e) => e.target.style.color = '#000000'}
                onMouseLeave={(e) => e.target.style.color = '#525252'}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <a
              href="tel:+74991105752"
              className="header-phone"
              style={{
                color: '#0F0F1A',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 600,
                transition: 'color 0.2s',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={(e) => e.target.style.color = '#8B5CF6'}
              onMouseLeave={(e) => e.target.style.color = '#0F0F1A'}
            >
              +7 (499) 110-57-52
            </a>
            <button
              className="header-cta"
              style={{
                padding: '8px 16px',
                background: '#000000',
                color: '#ffffff',
                fontSize: '14px',
                fontWeight: 500,
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                transition: 'background 0.2s',
              }}
              onClick={() => window.dispatchEvent(new Event('openModal'))}
              onMouseEnter={(e) => e.target.style.background = '#262626'}
              onMouseLeave={(e) => e.target.style.background = '#000000'}
            >
              Оставить заявку
            </button>
            <button
              className="header-burger"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{
                padding: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <svg style={{ width: '20px', height: '20px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav style={{ padding: '16px 0', borderTop: '1px solid rgba(229, 229, 229, 1)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
              {navItems.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  style={{ color: '#525252', textDecoration: 'none', transition: 'color 0.2s', cursor: 'pointer' }}
                  onClick={() => setIsMenuOpen(false)}
                  onMouseEnter={(e) => e.target.style.color = '#000000'}
                  onMouseLeave={(e) => e.target.style.color = '#525252'}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="tel:+74991105752"
                style={{ color: '#0F0F1A', textDecoration: 'none', fontWeight: 600, fontSize: '16px', marginTop: '8px' }}
              >
                +7 (499) 110-57-52
              </a>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  window.dispatchEvent(new Event('openModal'));
                }}
                style={{
                  display: 'inline-flex',
                  justifyContent: 'center',
                  padding: '8px 16px',
                  background: '#000000',
                  color: '#ffffff',
                  fontSize: '14px',
                  fontWeight: 500,
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  marginTop: '8px',
                }}
                onMouseEnter={(e) => e.target.style.background = '#262626'}
                onMouseLeave={(e) => e.target.style.background = '#000000'}
              >
                Оставить заявку
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
